// React component that will return image, if latin latin.svg, if standard standard.svg

import React from "react";
import { Image } from "@aws-amplify/ui-react";

interface DisciplineProps {
  discipline: string;
}

const DisciplineImage: React.FC<DisciplineProps> = ({ discipline }) => {
  return (
    <Image
      src={
        discipline === "Latin"
          ? "/disciplines/latin.svg"
          : "/disciplines/standard.svg"
      }
      alt={discipline}
      title={discipline}
    />
  );
};

export default DisciplineImage;
